import { Fragment } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../reducers';
import Typography from '../../atoms/Typography';

export interface SuggestedTopicsProps {
  handleAddSuggestedTopic: (topic) => void;
}
function SuggestedTopics({ handleAddSuggestedTopic }: SuggestedTopicsProps) {
  const suggestedTopics = useSelector(({ data }: RootState) => data.suggestedTopics.data);

  return (
    <div className="flex pt-2 flex-wrap items-center">
      <Typography variant="base" className="inline pr-1">
        Suggested:
      </Typography>
      {suggestedTopics.map((topic, index) => {
        return (
          <Fragment key={topic.value}>
            <Typography
              variant="base"
              className="cursor-pointer text-glooBlue-600 text-sm inline hover:font-semibold"
              onClick={() => handleAddSuggestedTopic(topic)}
            >
              {topic.title}
            </Typography>
            <Typography variant="sm" className="pr-1">{`${suggestedTopics.length > index + 1 ? ', ' : ''}`}</Typography>
          </Fragment>
        );
      })}
    </div>
  );
}

export default SuggestedTopics;
